import React from 'react';
import logo from '../images/logo.png';

const ImazenSection = ({ visible, onReject, onAccept }) => (
    <>
    <section className="imazen-side" style={{ display: visible ? 'flex' : 'none' }}>
        <div className="centered-text">
            <div>
                <div className="title-with-tagline">
                    <span><strong><img src={logo} alt='logo-Imazen' className='logo-Imazen' />Imazen</strong></span>
                    <p className="tagline"><i>Imagine | Generate | Share</i></p>
                </div>
                <p className="imazen-description">
                    What if your imagination didn’t have limits - and you could share it instantly with the world? <br />
                    Imazen is a new kind of social platform built for AI-generated images. Create, modify, and share your generations. Follow your friends and discover what others are bringing to life.<br />
                    <p style={{marginTop: "8px"}}><strong>Why Imazen?</strong><br /></p>
                    Today, there are plenty of social media apps, but most of them have become too personal. You’re expected to share the perfect picture on Instagram, craft the perfect tweet for retweets, or post updates about your real life.<br />
                    We realized that AI-generated images didn’t really have a place on those platforms - they weren't built for it. So we created Imazen: a place where you don't have to post perfect images. Just imagine and generate. Every creation is unique; it doesn't have to be good or perfect.<br />
                    Post whatever you create, let your friends see what you’re imagining, and get inspired by what others are generating.<br />
                    There’s nothing to be shy about, nothing to feel embarrassed about, nothing to feel awkward about - just create and bring your imagination into existence.<br /><br />
                    <p style={{color: 'white', fontSize:'2vh'}}><strong>Think it's worth giving a shot?</strong></p>
                    <p className="button-group">
                    <button className="green-button" onClick={onAccept}>Yeah, I think so</button>

                        <button className="orange-button" onClick={onReject}>Nah I'm good</button>
                    </p>
                </p>
                <p className='Launch'>Launching Soon . . .</p>
            </div>
            
        </div>
    

    </section>
    </>
);

export default ImazenSection;
